import React from 'react';
import ReactDOM from 'react-dom';
class Projects extends React.Component {         
    render() { 
       return ( 
          <div>Projects</div> 
       ); 
    }
 }
 export default Projects;